import { AiOutlineQuestionCircle } from 'react-icons/ai'
import { BsFillArrowLeftCircleFill, BsFillArrowRightCircleFill } from "react-icons/bs";
import { RiCloseCircleFill } from "react-icons/ri";

import { this_device } from './Global/Device'

import tutorial1 from './../img/tutorial/tutorial_01.png'
import tutorial2 from './../img/tutorial/tutorial_02.png'
import tutorial3 from './../img/tutorial/tutorial_03.png'

import './../css/tutorial.css'

function toggleTutorialPopup(e) {
    var popup = document.querySelector('.tutorial-popup-wrapper');
    popup.toggleAttribute('active');
}

function prevStep(e) {
    var container = document.querySelector('.tutorial-popup-content');
    var currentStep = parseInt(container.getAttribute('activestep'));

    setStep(currentStep - 1);
}
function nextStep(e) {
    var container = document.querySelector('.tutorial-popup-content');
    var currentStep = parseInt(container.getAttribute('activestep'));

    setStep(currentStep + 1);
}
function setStep(step) {
    if (step >= 1 && step <= 3) {
        var imageSource;
        switch (step) {
            case 1:
                imageSource = tutorial1;
                break;
            case 2:
                imageSource = tutorial2;
                break;
            case 3:
                imageSource = tutorial3;
                break;
            default:
                imageSource = "";
                break;
        }

        var container = document.querySelector('.tutorial-popup-content');
        var image = container.querySelector('.tutorial-image');

        var leftBtn = document.querySelector('.left-tutorial-btn');
        var rightBtn = document.querySelector('.right-tutorial-btn');

        leftBtn.removeAttribute('hidden');
        rightBtn.removeAttribute('hidden');

        if (step === 1) {
            leftBtn.setAttribute('hidden', '');
        }
        else if (step === 3) {
            rightBtn.setAttribute('hidden', '');
        }

        container.setAttribute('activestep', step);
        image.src = imageSource;
        image.alt = `Tutorial step ${step}`;
    }
}

export const Tutorial = () => {
    return (
        <span>
            <div onClick={toggleTutorialPopup}>
                <AiOutlineQuestionCircle />
            </div>

            <div className="tutorial-popup-wrapper" onClick={toggleTutorialPopup}>
                <div className="tutorial-popup-container no-scrollbar" onClick={(e) => e.stopPropagation()}>
                    <div className="tutorial-popup-content" activestep="1">
                        <img className="tutorial-image" src={tutorial1} alt="Tutorial step 1" />

                        <div className="left-tutorial-btn" onClick={prevStep} hidden><BsFillArrowLeftCircleFill /></div>
                        <div className="right-tutorial-btn" onClick={nextStep}><BsFillArrowRightCircleFill /></div>
                    </div>

                    <div className="exit-tutorial-btn" onClick={toggleTutorialPopup}><RiCloseCircleFill /></div>

                </div>

                <div style={{ position: "fixed", right: "0.5rem", bottom: "0.5rem", color: "white", fontSize: "0.7rem" }}>
                    Version: {process.env.REACT_APP_VERSION}<br />
                    Device: {this_device.deviceType}<br />
                    Touchscreen: {(this_device.isTouchDevice) ? "yes" : "no"}
                </div>

            </div>

        </span>
    )
}

export default Tutorial